<div cdkTrapFocus aria-live="assertive">
  <div class="modal-header">
    <h2 class="modal-title" i18n="@@modalFasttrackDetails" id="modal-header">Fast Track Details</h2>
    <button
      type="button"
      class="close"
      aria-label="Close"
      ngbAutoFocus
      (click)="activeModal.dismiss()"
    >
      <span aria-hidden="true"><i class="ico-cancel modal_exit_cross"></i></span>
    </button>
  </div>
  <div class="modal-body">
    <app-fast-track-details [fastTrack]="item"></app-fast-track-details>
  </div>
</div>
